<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()"
        class="d-flex flex-column justify-content-center align-items-center w-100">
        <div class="dialog-title">
            <h4>{{ getTitle() }}</h4>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
                style="position:absolute; top:0; right:0;">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="w-100">
            <input type="hidden" id="id" name="id" formControlName="id">
            <div class="d-flex flex-row p-2">
                <div class="d-flex flex-column justify-content-between w-100 p-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label for="name">Nazwa</mat-label>
                        <input matInput tabindex="1" type="text" formControlName="name" required>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label for="type">Typ</mat-label>
                        <mat-select formControlName="type">
                            @for (item of types; track item) {
                            <mat-option [value]="item.value">{{item.name}}</mat-option>
                            }
                        </mat-select>
                </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label for="val">Wartość</mat-label>
                        <input matInput tabindex="3" type="text" formControlName="val" required>
                    </mat-form-field>

                    <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2" >
                        <button mat-flat-button color="warn" mat-dialog-close class="w-b">Anuluj</button>
                        <button mat-flat-button color="accent" type="submit" [disabled]="checkDisabled()" 
                        class="w-b">{{ getButtonText() }}</button>
                    </mat-dialog-actions>
            
                </div>
            </div>

        </mat-dialog-content>
    </form>
</div>